import { APIService } from './APIService';

export const ValidateUserAccess = () => {
  return APIService({
      endpoint: "/account/access/",
      method: "GET"
  });
};